// extracted by mini-css-extract-plugin
export default {"wrapper":"rWzZXNW","image":"qg0Nbnf","title-link":"JCI1JZl","titleLink":"JCI1JZl","title":"qvykAqY","text":"_7A+fN8D","link":"xDF-W+l","link-icon":"_4C6H5gF","linkIcon":"_4C6H5gF"};